export const FIND_BIKE_REQUEST = 'FIND_BIKE_REQUEST';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/constants/find_bike.constants.js